import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import de from "../locales/de.json";
import en from "../locales/en.json";
import sv from "../locales/sv.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: en },
			sv: { translation: sv },
			de: { translation: de },
		},
		fallbackLng: "en",
		// Restrict to languages we ship a translation for. Without
		// this, browsers reporting "fr-CA" / "de-AT" / etc. fall back
		// to the closest matching code via LanguageDetector — but the
		// detector also accepts entirely unsupported codes (e.g.
		// "ja"), which then renders raw "nav.foo" keys at every t()
		// call site.  fallbackLng catches the unsupported path; we
		// keep supportedLngs explicit + nonExplicitSupportedLngs=true
		// so "de-AT" maps to "de" transparently.
		supportedLngs: ["en", "sv", "de"],
		nonExplicitSupportedLngs: true,
		interpolation: { escapeValue: false },
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
			lookupLocalStorage: "agntspace-lang",
		},
	});

export default i18n;
